import { render, staticRenderFns } from "./profile-mailbox.vue?vue&type=template&id=799b5974&scoped=true&"
import script from "./profile-mailbox.ts?vue&type=script&lang=ts&"
export * from "./profile-mailbox.ts?vue&type=script&lang=ts&"
import style0 from "./profile-mailbox.scss?vue&type=style&index=0&id=799b5974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b5974",
  null
  
)

export default component.exports